import Button from '../components/Button';
import { useState } from 'react';
import CreateOrderScreen from '../screens/CreateOrderScreen';
import {ReactComponent as BackIcon} from '../components/svgs/backIcon.svg'
import CreateServiceForm from './manager/CreateServiceForm';
import CreateEmployeeForm from './manager/CreateEmployeeForm';
import CreateCustomerFormExpanded from './CreateCustomerFormExpanded';
// import CreateCustomerForm from './CreateCustomerForm';

import { useNavigate } from 'react-router-dom';


const DetailsPageHeader = ({ pageName, customerDetails, showButton, showCreateCustomerButton, showServicesButton, showEmployeesButton }) => {
  const navigate = useNavigate();
  const [isSidePageOpen, setIsSidePageOpen] = useState(false);
  // const [isSideOrderPageOpen, setIsSideOrderPageOpen] = useState(false); 

  const handleOpenButtonClick = () => {
    setIsSidePageOpen(true);
  };

  const handleCloseButtonClick = () => {
    setIsSidePageOpen(false);
  };

  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };


 

  const handleCancel = () => {
    setShowSidePage(false);
  };

  const [showSidePage, setShowSidePage] = useState(false);

  const toggleSidePage = () => {
    setShowSidePage(!showSidePage);
  };


  return (
    <>
      <section className='flex header-section'>
        <div className='flex gap-4'>
          <div className='back-icon-container' onClick={handleBackClick}>
            <BackIcon />
          </div>
          <p className='order-back-text'>Go Back</p>
          <p className='order-back-text order-text-back-par'>{pageName}/ <span>{customerDetails}</span></p>
        </div>
        {showButton && (
          <div className='header-btn-section'>
            <div>
              <Button onClick={handleOpenButtonClick}>Create an order</Button>
              <div className="overlay" onClick={handleCloseButtonClick} style={{ display: isSidePageOpen ? 'block' : 'none' }}></div>
              <CreateOrderScreen isOpen={isSidePageOpen} onClose={handleCloseButtonClick} />
            </div>
          </div>
        )}
        
        {showCreateCustomerButton && (
                <div className=''>
                  <div className='header-btn-section'>
                    <div className="customer-side-container">
                      {/* Button to trigger the side page */}
                      <Button onClick={toggleSidePage}>Create Customer</Button>

                      {/* Overlay behind the side page */}
                      {showSidePage && <div className="overlay2" onClick={toggleSidePage}></div>}

                      {/* Side page itself */}
                      <div className={`customer-side-page ${showSidePage ? 'active' : ''}`}>
                        <div className="content">
                            <h2 className="create-order-page-title">Create Customer</h2>
                            <p className="create-order-page-subtitle">Fill out these details to proceed</p>
                        </div>
                        {/* Your form components can go here */}
                        <CreateCustomerFormExpanded OnCancel={handleCancel}/>
                      </div>
                    </div>

                  </div>
                </div>
            )}
            

              {showServicesButton && (
                <div className=''>
                <div className='header-btn-section'>
                  <div className="customer-side-container">
                    {/* Button to trigger the side page */}
                    <Button onClick={toggleSidePage}>Create a service</Button>

                    {/* Overlay behind the side page */}
                    {showSidePage && <div className="overlay2" onClick={toggleSidePage}></div>}

                    {/* Side page itself */}
                    <div className={`customer-side-page ${showSidePage ? 'active' : ''}`}>
                      <div className="content">
                          <h2 className="create-order-page-title">Add a service</h2>
                          <p className="create-order-page-subtitle">Fill out these details to proceed</p>
                      </div>
                      {/* Your form components can go here */}
                      <CreateServiceForm OnCancel={handleCancel}/>
                    </div>
                  </div>

                </div>
              </div>
              )}

              {showEmployeesButton && (
                <div className=''>
                <div className='header-btn-section'>
                  <div className="customer-side-container">
                    {/* Button to trigger the side page */}
                    <Button onClick={toggleSidePage}>Add an Employee</Button>

                    {/* Overlay behind the side page */}
                    {showSidePage && <div className="overlay2" onClick={toggleSidePage}></div>}

                    {/* Side page itself */}
                    <div className={`customer-side-page ${showSidePage ? 'active' : ''}`}>
                      <div className="content">
                          <h2 className="create-order-page-title">Add a employee</h2>
                          <p className="create-order-page-subtitle">Fill out these details to proceed</p>
                      </div>
                      {/* Your form components can go here */}
                      <CreateEmployeeForm OnCancel={handleCancel}/>
                    </div>
                  </div>

                </div>
              </div>
              )}
      </section>
    </>
  )
}

export default DetailsPageHeader;
